gz-input {
  margin-top: 20%;
}

gz-button {
  bottom: 16px;
  position: absolute;
}

gz-card {
  margin: 0;
}

gz-form-field {
  gz-text {
    font-size: var(--body-size-medium);
    text-align: right;
  }
}
